"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrHeaderLayout = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_fusion_fdr_header_logo_1 = require("@hotelplan/fdr.regular.fusion.fdr-header-logo");
const HeaderWrap = styled_components_1.default.div.attrs({ 'data-id': `header-wrap` })(({ theme }) => theme.header.wrap);
const HeaderBody = styled_components_1.default.header(({ theme }) => theme.header.body);
const FdrHeaderLayout = ({ children, logo, logoRouterProps, className }) => {
    return (react_1.default.createElement(HeaderWrap, { className: className },
        react_1.default.createElement(HeaderBody, null,
            react_1.default.createElement(fdr_regular_fusion_fdr_header_logo_1.FdrHeaderLogo, { logo: logo, logoRouterProps: logoRouterProps }),
            children)));
};
exports.FdrHeaderLayout = FdrHeaderLayout;
//# sourceMappingURL=fdr-header-layout.js.map